// TODO: move to ../node/runtime/html/NOT_SERIALIZABLE.ts once code is distributed as ESM
export const NOT_SERIALIZABLE = '__VIKE__NOT_SERIALIZABLE__';
